import dayjs from "@/helpers/dayjs";

export const DEFAULT_MAX_LOAN_DAYS = 3;

export function positiveIntOrNull(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const n = Number(value);
  if (!Number.isFinite(n) || n < 1) {
    return null;
  }
  return Math.floor(n);
}

export function effectiveMaxLoanDays(override, ownerValue) {
  const own = positiveIntOrNull(override);
  if (own !== null) {
    return own;
  }
  const inherited = positiveIntOrNull(ownerValue);
  if (inherited !== null) {
    return inherited;
  }
  return DEFAULT_MAX_LOAN_DAYS;
}

export function knownMaxLoanDays(loanable) {
  if (!loanable) {
    return null;
  }
  if (positiveIntOrNull(loanable.max_loan_days) !== null) {
    return positiveIntOrNull(loanable.max_loan_days);
  }
  if (
    loanable.owner &&
    Object.prototype.hasOwnProperty.call(loanable.owner, "max_loan_days")
  ) {
    return effectiveMaxLoanDays(null, loanable.owner.max_loan_days);
  }
  if (
    Object.prototype.hasOwnProperty.call(loanable, "max_loan_days") &&
    !loanable.owner
  ) {
    return DEFAULT_MAX_LOAN_DAYS;
  }
  return null;
}

// Same count as Loan::getCalendarDays: the departure day counts as 1,
// and a return exactly at midnight does not start the next day.
export function loanDayCount(departureAt, durationInMinutes) {
  if (!departureAt) {
    return 0;
  }
  const start = dayjs(departureAt);
  const end = dayjs(departureAt).add(Number(durationInMinutes) || 0, "minute");
  if (!end.isAfter(start)) {
    return 0;
  }
  const endIsMidnight = end.hour() === 0 && end.minute() === 0 && end.second() === 0;
  const endParts = endIsMidnight
    ? { year: end.year(), month: end.month(), date: end.date() }
    : nextDateParts(end.year(), end.month(), end.date());
  const startUtc = Date.UTC(start.year(), start.month(), start.date());
  const endUtc = Date.UTC(endParts.year, endParts.month, endParts.date);
  return Math.round((endUtc - startUtc) / 86400000);
}

function nextDateParts(year, month, date) {
  const next = new Date(year, month, date + 1);
  return { year: next.getFullYear(), month: next.getMonth(), date: next.getDate() };
}

export function maxLoanDaysMessage(max) {
  return `Cette réservation dépasse le maximum de jours autorisé qui est de ${max}.`;
}
